<template>
  <TransactionFormAsset v-bind="{ ...$attrs, instance }" :entry-index="3" />
</template>

<script setup lang="ts">
import { TransactionClass } from '..'

import TransactionFormAsset from './TransactionFormAsset.vue'

type Props = {
  instance: TransactionClass
}

defineProps<Props>()
</script>
